import LabelToggle from './LabelToggle.component';

export default LabelToggle;
